/**
 * Accordion
 *
 * @example
 * accordion();
 *
 * @param {string} trigger
 * @param {string} parent
 * @param {Object} opt
 *
 * @returns {void}
 */
const accordion = (trigger, parent, opt = {}) => {

    $(trigger).off('click', trigger_func);
    $(trigger).on('click', trigger_func);

    const defaults = {
        item: '.accordion__item',
        body: '.accordion__body',
        active_class: 'is-opened'
    };
    let options = Object.assign(defaults, opt);

    //console.log(options);

    function trigger_func() {
        const current = $(this).parent(parent);
        const current_body = $(this).parent(parent).find(options.body);

        $(options.item + ':not("' + options.active_class + '")').each(function () {
            $(this).removeClass(options.active_class).find(options.body).slideUp();
        });

        if (!current_body.is(":visible")) {
            current.addClass(options.active_class).find(options.body).slideDown();
        }
    }
};

export default accordion;
